exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3b89b15a] .el-card__header {\n  background: #f5f7fa;\n}\n.info[data-v-3b89b15a] {\n  color: #333;\n}\n", ""]);

// exports
